export default {
  payWelfareText: 'Benefícios de recarga',
  blackFridayDiscount: 'Desconto cronometrado da Black Friday',
  shareGift: 'Compartilhar Presente',
  vipWeeklyWelfare: 'Desconto Semanal VIP',
  exchangeCoupon: 'Cupom',
  firstPayOff: 'Até 15% de Desconto na 1ª compra',
  blackFridayEvent: 'Evento de Black Friday',
  limitedTimeOff: '10% de desconto por Tempo Limitado',
  claimCoupon: 'Resgate agora',
  blackFridayTimedCoupon: 'Cupom de Black Friday por tempo limitado',
  timeLeft: 'Tempo restante:',
  claimTimeCoupon: 'Solicite cupom de 10% de desconto agora!',
  points: 'Pontos: ${point}',
  costPointTip: 'Troque pontos por cupons',
  maxPointTip: 'Cada conta pode usar até 500 pontos.',
  discountOff: '10% DE DESCONTO',
  highestDiscount: 'ATÉ  ${discount} DE DESCONTO',
  needPoint: 'Requer ${point} pontos',
  changeCurrency: 'Alterar moeda',
  claim: 'Resgatar',
  claimSucc: 'Resgatado',
  claimFail: 'Falhou',
  pointNotEnough: 'Pontos insuficientes',
  afterClaimPoint: 'Pontos restantes: ${point}',
  footTips1: 'Apenas 1 cupom pode ser usado para cada pedido.',
  footTips2: 'O cupom não pode ser usado para comprar moedas/tokens no jogo.',
  footTips3: 'Reservamo-nos o direito da interpretação final deste evento.',
  ruleTitleText: 'Regras do Evento',
  ruleTime:
    'Duração do evento: 00h00 de 24 de novembro de 2023 até 23h59 de 26 de novembro de 2023 (UTC)',
  bfRuleText1:
    '1. 400 pontos serão concedidos à sua conta quando você fizer login na página oficial de recarga pela primeira vez durante o evento. Você pode trocar até 500 pontos por cupons.',
  bfRuleText2:
    '2. Você poderá trocar pontos da Black Friday por cupons durante o evento.',
  bfRuleText3:
    '3. Você só poderá utilizar 1 cupom por cada pedido. Os cupons não podem ser usados para comprar moedas/tokens no jogo.',
  bfRuleText4: '4. Para transações, aceitamos apenas as seguintes moedas:',
  ableCoinsType: '/',
  bfRuleText5:
    '5. Você não pode alterar a moeda após a transação ser realizada. Os pontos trocados não podem ser reembolsados.',
  bfRuleText6: '6. Os cupons da Black Friday serão válidos apenas por 7 dias.',
  bfRuleText7: '7. Reservamo-nos o direito da interpretação final deste evento.',
  thanksTip:
    'Obrigado pela sua participação. Participe da nossa comunidade oficial para obter mais informações sobre o evento.',
  exchangePoints: 'Trocar',
  exchangeCode: 'Insira o código de troca.',
  enterExchangeCode: 'Insira o código de troca.',
  exchangeText: 'Trocar',
  confirmGet: 'Confirmar',
  couponUsedWay:
    'O cupom só pode ser usado com moedas específicas. Confirme sua moeda.',
  confirmText: 'Confirmar',
  exchangeSucc: 'Trocado',
  aboutCoins: 'Sobre moedas/tokens no jogo',
  aboutCoinsText:
    'Você pode trocar moedas/tokens do jogo por todos os pacotes e privilégios, exceto pela própria moeda/token do jogo.',
  known: 'OK',
  codeText: 'Código',
  codeInvalid: 'Código inválido!',
  hasExchanged: 'Você não pode resgatar mais códigos.',
  hideText: 'Esconder',
  //黑五的报错码
  'bf-20001': 'Não logado',
  'bf-20002': 'Erro de parâmetro. Tente entrar novamente no evento.',
  'bf-20003': 'Pontos insuficientes',
  'bf-20004':
    'Falha. Tente novamente mais tarde ou entre em contato com o Suporte ao Cliente.',
  'bf-20005': 'Resgatado',
  'bf-20015': 'O evento não está disponível no momento.',
  'bf-20016': 'O evento terminou.',
  bfShareText: 'Solicite cupom de 10% de desconto agora!',
  rightsCenterBtn: 'Centro de Membros Premium',
  payBtn: 'RECARGA',
  hasEqualRewardMuglo: 'Até 1800 diamantes de BÔNUS na recarga do site oficial!',
  productInterceptPopupTitle: 'Purchase Failed',
  productInterceptPopupTip: 'This item is not available in your region.<br>Please contact customer support if you have any questions.',
  productInterceptPopupConfirm: 'OK',
  vipHeadAwardText285 : 'Extraordinário Glorioso (Permanente)',
  '-': '-'
};
